import { render } from "./CustomInput.vue?vue&type=template&id=148079ee&scoped=true&ts=true"
import script from "./CustomInput.vue?vue&type=script&lang=ts"
export * from "./CustomInput.vue?vue&type=script&lang=ts"

import "./CustomInput.vue?vue&type=style&index=0&id=148079ee&lang=scss&scoped=true"

import exportComponent from "/builds/rma/ufg-rma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148079ee"]])

export default __exports__